var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0428 0L10.2 7.24286H12.6L18 0H15.0428Z",
    fill: "#A2AACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6001 0L7.80005 7.24286H10.2L15.0429 0H12.6001Z",
    fill: "#757A88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 0L5.39996 7.24286H7.79996L12.6 0H10.2Z",
    fill: "#474C5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 25.7143C13.8758 25.7143 17.8285 21.7616 17.8285 16.8857C17.8285 12.0098 13.8758 8.05713 8.99996 8.05713C4.12407 8.05713 0.171387 12.0098 0.171387 16.8857C0.171387 21.7616 4.12407 25.7143 8.99996 25.7143Z",
    fill: "#FFD23B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89086 15.6651L10.0044 15.9062L10.268 15.9463L12.3071 16.2567L10.8163 17.7787L10.6391 17.9596L10.68 18.2095L11.0272 20.3277L9.24117 19.3444L9.00002 19.2117L8.75887 19.3444L6.97286 20.3277L7.32 18.2095L7.36094 17.9596L7.18378 17.7787L5.69296 16.2567L7.73208 15.9463L7.9956 15.9062L8.10918 15.6651L9.00002 13.7739L9.89086 15.6651Z",
    fill: "#474C5A",
    stroke: "#343843"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58567 5.61426C4.37138 5.61426 4.19995 5.78569 4.19995 5.99997V9.59997C4.19995 9.81426 4.37138 9.98569 4.58567 9.98569H13.4142C13.6285 9.98569 13.8 9.81426 13.8 9.59997V5.99997C13.8 5.78569 13.6285 5.61426 13.4142 5.61426H4.58567ZM13.0285 8.44283C13.0285 8.65712 12.8571 8.82854 12.6428 8.82854H5.39995C5.18567 8.82854 5.01424 8.65712 5.01424 8.44283V6.81426C5.01424 6.59997 5.18567 6.42854 5.39995 6.42854H12.6428C12.8571 6.42854 13.0285 6.59997 13.0285 6.81426V8.44283Z",
    fill: "#FFD23B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.41429 17.9143C1.41429 13.1143 5.10001 9.21433 9.81429 8.87147C9.60001 8.87147 9.34286 8.82861 9.12858 8.82861C4.62858 8.82861 0.985718 12.4715 0.985718 17.0143C0.985718 18.3429 1.32857 19.6286 1.88572 20.7429C1.58572 19.8429 1.41429 18.9 1.41429 17.9143Z",
    fill: "#89664C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M12.3857 23.7C16.3714 21.0429 17.5714 15.8572 15.2571 11.8286L15.6429 12.3429C18.1286 16.0286 17.1 21.0429 13.3714 23.5715C12.2571 24.3429 11.0143 24.7715 9.77142 24.9C10.7143 24.6429 11.5714 24.2572 12.3857 23.7Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 7.24286H7.8L2.95714 0H0L5.4 7.24286Z",
    fill: "#474C5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80001 7.24286H10.2L5.40001 0H2.95715L7.80001 7.24286Z",
    fill: "#757A88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.38573 1.19995L8.18573 2.99995L11.0143 7.24281H12.6L13.0286 6.64281L9.38573 1.19995Z",
    fill: "#3E4347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 7.24286H12.6L7.79996 0H5.39996L10.2 7.24286Z",
    fill: "#A2AACA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal_.aafa2f93.svg";
export { ForwardRef as ReactComponent };